/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface ShareRequestBody
 */
export interface ShareRequestBody  {
    /**
     * 
     * @type {Array<string>}
     * @memberof ShareRequestBody
     */
    apiKeys?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ShareRequestBody
     */
    destinationUser?: number;
}

/**
 * Check if a given object implements the ShareRequestBody interface.
 */
export function instanceOfShareRequestBody(value: object): value is ShareRequestBody {
    return true;
}

export function ShareRequestBodyFromJSON(json: any): ShareRequestBody {
    return ShareRequestBodyFromJSONTyped(json, false);
}

export function ShareRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShareRequestBody {
    if (json == null) {
        return json;
    }
    return {
        
              'apiKeys': json['apiKeys'] == null ? undefined : json['apiKeys'],
                  'destinationUser': json['destinationUser'] == null ? undefined : json['destinationUser'],
    };
}

export function ShareRequestBodyToJSON(json: any): ShareRequestBody {
    return ShareRequestBodyToJSONTyped(json, false);
}

export function ShareRequestBodyToJSONTyped(value?: ShareRequestBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'apiKeys': value['apiKeys'] == null? value['apiKeys']: value['apiKeys'],
        'destinationUser': value['destinationUser'],
    };
}


